import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const StatCard = ({ title, value, icon, trend, trendValue, colorClass, delay = 0 }) => {
  const isPositive = trend === 'up';

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay }}
      className="card p-6"
    >
      <div className="flex justify-between items-start mb-4">
        <div>
          <p className="text-sm font-medium text-gray-500 mb-1">{title}</p>
          <h3 className="text-2xl font-bold text-gray-800">{value}</h3>
        </div>
        <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${colorClass}`}>
          <SafeIcon name={icon} size={24} />
        </div>
      </div>
      
      <div className="flex items-center text-sm mt-4">
        <span className={`flex items-center font-medium ${isPositive ? 'text-green-500' : 'text-red-500'}`}>
          <SafeIcon name={isPositive ? 'TrendingUp' : 'TrendingDown'} size={16} className="mr-1" />
          {trendValue}
        </span>
        <span className="text-gray-400 ml-2">vs last month</span>
      </div>
    </motion.div>
  );
};

export default StatCard;